<template>
  <main>
    Hello
  </main>
</template>

<script>
export default {

}
</script>

<style>

</style>